module.exports = __webpack_public_path__ + "img/huiyuan.9303b9ef.svg";